<template>
    <div class="animated fadeIn">
        <b-row style="margin-bottom:20px;">
            <b-col lg="6" md="6" sm="6" class="col-toggle">
                <b-button style="margin-right:20px;" @click="refresh()">{{ $t('client.refresh') }}</b-button>
                <span> {{ $t('client.show_card') }} </span> 
                <c-switch class="mx-1" color="primary" v-model="showTable" :checked="showTable" variant="pill" />
                <span> {{ $t('client.show_table') }} </span> 
            </b-col>
            <b-col lg="6" md="6" sm="6" class="col-toggle">
                <b-form-input id="basicsearch" type="search" v-model="searchText" autocomplete="search"></b-form-input>
                <b-button style="margin-right:20px;" @click="search()">{{ $t('client.search') }}</b-button>
            </b-col>
        </b-row>
        <b-row v-if="!showTable">
            <b-col sm="6" lg="4" v-for="client in items">
                <b-card>
                    <div class="h4 m-0">
                        <router-link :to="{ name: 'SingleClient', params: { id: client.id }}" v-b-tooltip.hover title="Go to Client">{{client.first_name}} {{ client.last_name}}</router-link>
                    </div>
                    <div>{{ $t('client.email') }} : {{ client.email}}  </div>
                    <div>{{ $t('client.phone_number') }} : {{ client.phone_number}}  </div>
                    <div>{{ $t('client.address') }} : {{ client.address}}  </div>
                    <div>{{ $t('client.calendar_events') }} : {{ client.events.length }} </div>

                    <div :style="bmiStyle(client.bmi, client.sex)">BMI : {{ client.bmi }} </div>
                    <div :style="bmiStyle(client.bmi, client.sex)">BMR : {{ client.bmr }} </div>
                    <!-- <div>{{ $t('client.menus') }} : {{ client.menus.length + client.createdmenus.length }} </div> -->
                    <div>{{ $t('client.private_notes') }} : {{ client.private_notes.length}} </div>
                    <b-button class="button-notes" v-if="client.private_notes.length > 0" v-b-toggle="'collapse-'+client.id" variant="primary">{{ $t('client.notes') }}</b-button>
                    <b-collapse v-if="client.private_notes.length > 0" :id="'collapse-'+client.id" class="mt-2">
                        <b-card>
                            <div class="card-text" v-for="note in client.private_notes">{{note.content}}</div>
                        </b-card>
                    </b-collapse>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="showTable">
            <b-col lg="12">
                <table class="table">
                    <thead>
                        <th>{{ $t('client.full_name') }}</th>
                        <th>{{ $t('client.email') }}</th>
                        <th>{{ $t('client.phone_number') }}</th>
                        <th>{{ $t('client.address') }}</th>
                        <th>{{ $t('client.calendar_events') }}</th>
                        <th>{{ $t('client.private_notes') }}</th>
                        <th>{{ $t('menu.created_at') }}</th>
                    </thead>
                    <tbody>
                        <tr v-for="client in items">
                            <td>
                                <router-link :to="{ name: 'SingleClient', params: { id: client.id }}" v-b-tooltip.hover title="Go to Client">{{client.first_name}} {{ client.last_name}}</router-link>
                            </td>
                            <td> {{ client.email}}</td>
                            <td> {{ client.phone_number}} </td>
                            <td> {{ client.address}} </td>
                            <td> {{ client.events.length }} </td>
                            <td> {{ client.private_notes.length}} </td>
                            <td> {{ client.created_at}}</td>
                        </tr>
                    </tbody>
                </table>
                <!-- <b-table responsive="md" @click="tableClick($event)" :items="items" :fields="fields"></b-table> -->
            </b-col>
        </b-row>
    </div>
</template>

<script>

    import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
    import Models from '@/store/ORM/models.js';
    import { Switch as cSwitch } from '@coreui/vue';
    import ClientService from '@/services/client.service.js';

    export default {

        name: 'dashboard',

        components: {
            cSwitch
        },

        data: function () {

            return {
                showTable : false,
                items: [],
                searchText : "",
                fields: [
                    { key: 'id' },
                    { key: 'first_name' },
                    { key: 'last_name' },
                    { key: 'sex' },
                    { key: 'address' },
                    { key: 'bmi' },
                    { key: 'bmr' },
                    { key: 'dob' },
                    { key: 'email' },
                    { key: 'identification' },
                    // { key: 'weight_height_sets' },
                    { key: 'created_at' }
                ],
                user : Models.Nutritionist.query().first()
            }
        },

        methods: {

            refresh() {
                ClientService.getClients(this.user.id)
                .then(result => {
                    Models.Client.create({ data: result.data.results })
                        this.$store.dispatch('UserModules/SetClients', Models.Client.query().with('weight_height_sets').get())
                    })
                .catch(error => {
                    alert(error)
                });
            },

            search() {

                if(!!this.searchText) {

                    this.items = Models.Client.query().with('weight_height_sets').search(this.searchText, {
                    caseSensitive: false,
                    threshold: 0.3,
                    keys: ['first_name', 'last_name']
                }).with('events').with('menus').with('createdmenus').with('private_notes').get();
                }else{
                    this.items  = Models.Client.query().with('weight_height_sets').with('events').with('createdmenus').with('menus').with('private_notes').all();
                }
            },

            tableClick(evt){
                // console.log(evt);
            },

            /**
             *
            */
            bmiStyle: function(bmi, gender) {

                let bmiColor = "color:#000;";

                if(bmi != null && gender != null) {

                    if(gender == 'F') {
                        return this.calcFemaleBmi(bmi, 'F', bmiColor);
                    } else {
                       return this.calcMaleBmi(bmi, 'M', bmiColor);
                    }

                } else {
                    return bmiColor;
                }
            },

            /**
             *
            */
            calcFemaleBmi(bmi, gender, bmiColor) {

                if(bmi < 17.5) {
                    bmiColor = "color:#ff0000;";
                    //RED => anorexia

                } else if(bmi >= 17.5 && bmi < 19.1) {
                    bmiColor = "color:#ff9800;";
                    //orange => underweight

                } else if(bmi >= 19.1 && bmi < 25.8) {
                    bmiColor = "color:#00ff00;";
                    //green => normal

                } else if(bmi >= 25.8 && bmi < 27.3) {
                    bmiColor = "color:#ff9800;";
                    //orange => a little overweight

                } else if(bmi >= 27.3 && bmi < 32.3) {
                    bmiColor = "color:#ff0000;";
                    //red => overweight

                } else if(bmi > 32.3) {
                    bmiColor = "color:#ff0000;";
                    //red => Excess weight

                } else if(bmi >= 40 && bmi < 50) {
                    bmiColor = "color:#ff0000;";
                    //red => Overweight and morbid

                } else if(bmi >=50 && bmi <= 60) {
                    bmiColor = "color:#ff0000;";
                    //red => Overweight and morbid

                } else {
                    bmiColor = "color:#000000;";
                }

                return bmiColor;
            },

            /**
             *
            */
            calcMaleBmi(bmi, gender, bmiColor) {

                if (bmi < 17.5) {
                    bmiColor = "color:#ff0000;";
                    //RED => anorexia

                } else if(bmi >= 17.5 && bmi < 20.7) {
                    bmiColor = "color:#ff9800;";
                    //orange => underweight

                } else if(bmi >= 20.7 && bmi < 26.4) {
                    bmiColor = "color:#00ff00;";
                    //green => normal

                } else if(bmi >= 26.4 && bmi < 27.8) {
                    bmiColor = "color:#ff9800;";
                    //orange => a little overweight

                } else if(bmi >= 27.8 && bmi < 31.1) {
                    bmiColor = "color:#ff0000;";
                    //red => overweight

                } else if(bmi > 31.1) {
                    bmiColor = "color:#ff0000;";
                    //red => Excess weight

                } else if(bmi >= 40 && bmi < 50) {
                    bmiColor = "color:#ff0000;";
                    //red => Overweight and morbid

                } else if(bmi >= 50 && bmi <= 60) {
                    bmiColor = "color:#ff0000;";
                    //red => Overweight and morbid
                } else {
                    bmiColor = "color:#000000;";
                }

                return bmiColor;
            },

            /**
             *
            */
            bmrStyle(bmi, gender) {
                return this.bmiStyle(bmi, gender);
            },
        },

        created() {

            this.items = Models.Client.query().with('weight_height_sets').with('events').with('menus').with('private_notes').all();
            // console.log(this.items);
        },

        computed: {
            getUser : function() {
                return this.$store.state['UserModules'].user;
            }
        },
    }
</script>

<style>
    .m-0,.button-notes{
        margin-bottom: 10px;
    }

    .button-notes{
        margin-top: 10px;
    }
    .col-toggle{
        display:flex;
        align-items:center;
    }
</style>
